import { HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, tap } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

export const loadingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const loadingService = inject(LoadingService);

  let activeRequests = 0;

  activeRequests++;
  loadingService.setLoading(true);

  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        if (event.body && (event.body as { hideLoader?: boolean }).hideLoader) {
          loadingService.setLoading(false);
          return;
        }
      }
    }),
    finalize(() => {
      activeRequests--;
      if (activeRequests <= 0) {
        loadingService.setLoading(false);
      }
    }),
  );
};
